import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// import {faInstagram} from '@fortawesome/free-brands-svg-icons'
// import { faTwitter} from '@fortawesome/free-brands-svg-icons'
// import { faFacebook } from '@fortawesome/free-brands-svg-icons'
// import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
// import { faStarOfLife } from '@fortawesome/free-solid-svg-icons'
// import { faUsers } from '@fortawesome/free-solid-svg-icons'


export default function Footer() {
  return (
    <div>
        <div class="row">
<div class="col-xl-6 col-lg-6 text-center text-lg-left">
  
    {/* <div class="copyright-text">
        <p>Copyright &copy; 2023, All Right Reserved <span>Malhaar</span></p>
    </div> */}
</div>
</div>
<div class="media">

<p>
{/*           
          <a href="https://instagram.com/malhaarbpit?igshid=OGQ5ZDc2ODk2ZA=="> <FontAwesomeIcon icon={faInstagram} /></a>
           <a href="https://x.com/Malhaar_bpit?t=5NWXSmLS4YEUXgwFJFSIxw&s=09"> <FontAwesomeIcon icon={faTwitter} /></a>
            
            <a href="https://www.linkedin.com/in/malhaarbpit?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FontAwesomeIcon icon={faLinkedin}/></a>
            
            <a href="https://linktr.ee/bpit_malhaar"><FontAwesomeIcon icon={faStarOfLife}/></a>
            
            <div className='credits'><FontAwesomeIcon icon={faUsers} /></div> */}
            
          
            
</p>
          
           
      
   
</div>

</div>
  
  )
}
